<template>
  <div v-on:click="checkValue" class="card">
    <div class="card-image">
      <img :src="pathImg" class="photo" />
    </div>
    <div class="text-card" v-bind:class="{ checked: checked }">
      <p>{{ card.message }}</p>
      <div class="checkbox">
        <Checkbox @change="checkValue()" :bind="checked" :background="'white'" />
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '../Input/Checkbox';

export default {
  props: ['card', 'step', 'index'],
  name: 'SmallCard',
  components: {
    Checkbox,
  },
  computed: {
    checked() {
      return this.$store.getters.getChecked({ step: this.step, index: this.index });
    },
    pathImg() {
      return require('../../../assets/image-marque/quizz-step-' +
        String(this.step + 1) +
        '-' +
        String(this.index + 1) +
        '.jpg');
    },
  },
  methods: {
    checkValue() {
      return this.$store.dispatch('setChecked', { step: this.step, index: this.index });
    },
  },
};
</script>

<style scoped>
.card-image {
  max-height: 13vh;
  overflow: hidden;
}
.text-card {
  height: 3em;
  background: white;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.card {
  cursor: pointer;
  width: 33.33%;
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.card:hover .text-card > p {
  text-decoration: underline;
}
.card:nth-child(-n + 3) {
  padding-bottom: 1em;
}
.card:nth-child(1) {
  padding-left: 0;
}
.card:nth-child(4) {
  padding-left: 0;
}
img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.checked {
  background: #5e6a71;
}
.checked > p {
  color: white;
}
</style>
